import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { OverOnsPage } from "@/pages/over-ons";

export const Route = createFileRoute("/$lang/about")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "en";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/over-ons",
      title: t("over-ons.title"),
      description: t("over-ons.description"),
    });
  },
  component: OverOnsPage,
});
